import React, {useState} from 'react';
import './SNSLogin.scss';
import Button from "@material-ui/core/Button";
import {useHistory} from 'react-router-dom';
import axios from 'axios';
import CircleCompleteIcon from "../components/atom/icons/CircleCompleteIcon";
import CircleFailIcon from "../components/atom/icons/CircleFailIcon";

export default function SNSLogin(props) {

    console.log(props);
    const { success } = props;

    return (
        <div className="sns-login">
            {success === "success" ?
                <>
                    <div className={'login-icon'}>
                        <CircleCompleteIcon/>
                    </div>
                    <div className={'login-message'}>
                        로그인에 성공했습니다.
                    </div>
                </> :
                <>
                    <div className={'login-icon'}>
                        <CircleFailIcon/>
                    </div>
                    <div className={'login-message'}>
                        로그인에 실패했습니다.
                    </div>
                </>
            }
            <Button
                className={'complete-button'}
                variant={"contained"}
                color={"primary"}
                onClick={() => {
                    window.location.href = 'https://pikaburemote.page.link/6SuK';
                }}
            >
                확인
            </Button>
        </div>
    )
}
